export class RouteHome {
  static readonly type = '[Routing] Go Home';
}

export class RouteLogin {
  static readonly type = '[Routing] Go Login';
  constructor(public merchantId?: string) {}
}

export class RouteEmailMigration {
  static readonly type = '[Routing] Go Email Migration';
  constructor(public merchantId?: string) {}
}

export class RouteRegister {
  static readonly type = '[Routing] Go Register';
  constructor(public merchantId: string) {}
}

export class RouteAccount {
  static readonly type = '[Routing] Go Account';
}

export class RouteImprint {
  static readonly type = '[Routing] Go Imprint';
  constructor(public anchor: 'imprint' | 'tos' | 'privacy') {}
}

export class RouteTransactionDetails {
  static readonly type = '[Routing] Go Transaction Details';
  constructor(public saleId: string) {}
}

export class RouteCashcutDetails {
  static readonly type = '[Routing] Go Cashcut Details';
  constructor(public cashcutId: string) {}
}
